import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotifyService } from "../../../services/notify/notify-service";

export const useCreateNotify = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: (fields: any) => {
      return NotifyService.addNotify({ fields: fields });
    },
  });

  const addNotify = (body: any, options?: { onSuccess?: (res: any) => void }) => {
    mutate(body, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({ queryKey: ["notify"] });
        if (options?.onSuccess) options.onSuccess(response);
      },
    });
  };

  return { addNotify };
};
